var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPikkoBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 58,
    viewBox: "0 0 34 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.21285 13.7508C2.21285 13.7508 14.4955 12.9266 14.5791 25.859C1.37272 25.7769 2.21285 13.7508 2.21285 13.7508Z",
    fill: "#101110"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 12,
    width: 15,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4541 12.709H15.5653V26.6742H1.4541V12.709Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11392_37575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2967 26.5684L14.5744 26.5646C10.3148 26.5367 7.00179 25.308 4.72659 22.9065C1.16458 19.1494 1.48581 13.9288 1.50102 13.7088L1.54283 13.1028L2.16438 13.0599C2.16438 13.0599 2.33925 13.0469 2.64717 13.0469C4.7456 13.0469 15.213 13.6659 15.2929 25.8599L15.2967 26.5684Z",
    fill: "#101110"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 11,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6719 0H21.8903V19.3891H11.6719V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11392_37575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8412 19.1438L16.3337 18.6404C13.34 15.6721 11.8859 12.508 12.0114 9.23576C12.2072 4.11206 16.2025 0.644049 16.3736 0.500481L16.8412 0.0996094L17.3107 0.500481C17.4817 0.644049 21.4771 4.11206 21.6729 9.23576C21.7983 12.508 20.3443 15.6721 17.3506 18.6404L16.8412 19.1438Z",
    fill: "#101110"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.8175 13.7508C31.8175 13.7508 19.5367 12.9266 19.4512 25.859C32.6595 25.7769 31.8175 13.7508 31.8175 13.7508Z",
    fill: "#101110"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 12,
    width: 15,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4844 12.709H32.5955V26.6742H18.4844V12.709Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11392_37575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7334 26.5684L18.7391 25.8599C18.8189 13.6659 29.2864 13.0469 31.3829 13.0469C31.6927 13.0469 31.8676 13.0599 31.8676 13.0599L32.4872 13.1028L32.5309 13.7088C32.5461 13.9288 32.8674 19.1476 29.3054 22.9065C27.0321 25.308 23.7172 26.5367 19.4557 26.5646L18.7334 26.5684Z",
    fill: "#101110"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 34,
    height: 38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.477539 20.6465H33.5658V58.0003H0.477539V20.6465Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11392_37575)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 34,
    height: 39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9584 58.0033V20.6793C22.8462 20.6719 22.736 20.6719 22.6239 20.6719H11.4322V58.0033H22.9584ZM8.56401 58.0033H11.4322V20.6793H11.3695C6.73169 20.6793 2.66028 24.3916 2.32575 28.9242L0.75763 49.7677C0.413594 54.291 3.92808 58.0033 8.56401 58.0033ZM25.4275 58.0033C30.0653 58.0033 33.5779 54.291 33.2358 49.7584L31.6657 28.9168C31.3312 24.4941 27.4442 20.8527 22.9508 20.6793V58.0033H25.4275Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11392_37575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2597 58.0042H0.756836V20.6504H33.2597V58.0042Z",
    fill: "#111010"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 19,
    width: 15,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.7031H14.8144V34.2352H0V19.7031Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11392_37575)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 19,
    width: 15,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.40722 19.707C3.31681 19.707 0 22.9588 0 26.9731C0 30.9855 3.31681 34.2391 7.40722 34.2391C11.4976 34.2391 14.8144 30.9855 14.8144 26.9731C14.8144 22.9588 11.4976 19.707 7.40722 19.707Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11392_37575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.707H14.8144V34.2391H0V19.707Z",
    fill: "#101110"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 22,
    width: 11,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.79395 22.4277H12.0316V31.4912H2.79395V22.4277Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11392_37575)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 22,
    width: 11,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41472 22.4277C4.86391 22.4277 2.7959 24.4563 2.7959 26.9604C2.7959 29.4626 4.86391 31.4912 7.41472 31.4912C9.96553 31.4912 12.0335 29.4626 12.0335 26.9604C12.0335 24.4563 9.96553 22.4277 7.41472 22.4277Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11392_37575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7959 22.4277H12.0335V31.4912H2.7959V22.4277Z",
    fill: "#101110"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8.98384 28.1517C8.98384 27.0611 9.8127 26.275 10.9003 26.275C9.86324 26.275 8.98472 25.4375 8.98472 24.3973C8.98472 25.4276 8.16484 26.275 7.06738 26.275C8.16484 26.275 8.98384 27.1007 8.98384 28.1517Z",
    fill: "#101110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98384 24.3965L8.98472 24.3973M8.98472 24.3973C8.98472 25.4375 9.86324 26.275 10.9003 26.275C9.8127 26.275 8.98384 27.0611 8.98384 28.1517C8.98384 27.1007 8.16484 26.275 7.06738 26.275C8.16484 26.275 8.98472 25.4276 8.98472 24.3973Z",
    stroke: "#101110",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 38,
    width: 12,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8203 38.7031H22.301V47.8241H11.8203V38.7031Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11392_37575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0599 50.2129C16.7158 50.2129 16.3756 50.1764 16.0392 50.1021C15.7008 50.0292 15.3739 49.9199 15.0565 49.7756C14.739 49.6299 14.4368 49.4535 14.1517 49.2436C13.8647 49.0338 13.6005 48.7947 13.3572 48.528C13.1139 48.2598 12.8972 47.9698 12.7071 47.655C12.5152 47.3416 12.3536 47.0093 12.2225 46.6595C12.0913 46.3112 11.9925 45.9512 11.924 45.581C11.8575 45.2093 11.8252 44.8362 11.8252 44.4573C11.8252 44.0798 11.8575 43.7052 11.924 43.335C11.9925 42.9648 12.0913 42.6048 12.2225 42.255C12.3536 41.9067 12.5152 41.5744 12.7071 41.261C12.8972 40.9462 13.1139 40.6562 13.3572 40.388C13.6005 40.1213 13.8647 39.8822 14.1517 39.6724C14.4368 39.4625 14.739 39.2861 15.0565 39.1404C15.3739 38.9961 15.7008 38.8868 16.0392 38.8139C16.3756 38.7396 16.7158 38.7031 17.0599 38.7031C17.4039 38.7031 17.7441 38.7396 18.0806 38.8139C18.4189 38.8868 18.7458 38.9961 19.0633 39.1404C19.3807 39.2861 19.6829 39.4625 19.968 39.6724C20.255 39.8822 20.5192 40.1213 20.7625 40.388C21.0058 40.6562 21.2225 40.9462 21.4126 41.261C21.6046 41.5744 21.7661 41.9067 21.8973 42.255C22.0284 42.6048 22.1273 42.9648 22.1957 43.335C22.2622 43.7052 22.2945 44.0798 22.2945 44.4573C22.2945 44.8362 22.2622 45.2093 22.1957 45.581C22.1273 45.9512 22.0284 46.3112 21.8973 46.6595C21.7661 47.0093 21.6046 47.3416 21.4126 47.655C21.2225 47.9698 21.0058 48.2598 20.7625 48.528C20.5192 48.7947 20.255 49.0338 19.968 49.2436C19.6829 49.4535 19.3807 49.6299 19.0633 49.7756C18.7458 49.9199 18.4189 50.0292 18.0806 50.1021C17.7441 50.1764 17.4039 50.2129 17.0599 50.2129Z",
    fill: "#101110"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 43,
    width: 10,
    height: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.418 43.918H21.4807V50.3077H12.418V43.918Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11392_37575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.553 47.1108C21.553 47.2677 21.5226 47.4232 21.4656 47.5787C21.4067 47.7328 21.3211 47.8827 21.2071 48.0284C21.093 48.1741 20.9543 48.3114 20.7889 48.4431C20.6235 48.5734 20.4354 48.6952 20.2244 48.8059C20.0153 48.918 19.7853 49.0175 19.5382 49.1043C19.2911 49.1926 19.0307 49.2654 18.7551 49.3257C18.4795 49.3859 18.1963 49.4321 17.9055 49.463C17.6128 49.4938 17.3181 49.5092 17.0216 49.5092C16.7232 49.5092 16.4286 49.4938 16.1378 49.463C15.8451 49.4321 15.5618 49.3859 15.2862 49.3257C15.0125 49.2654 14.7502 49.1926 14.5031 49.1043C14.256 49.0175 14.026 48.918 13.817 48.8059C13.606 48.6952 13.4178 48.5734 13.2524 48.4431C13.0871 48.3114 12.9483 48.1741 12.8343 48.0284C12.7202 47.8827 12.6347 47.7328 12.5758 47.5787C12.5187 47.4232 12.4902 47.2677 12.4902 47.1108C12.4902 46.9525 12.5187 46.797 12.5758 46.6414C12.6347 46.4873 12.7202 46.3374 12.8343 46.1917C12.9483 46.046 13.0871 45.9088 13.2524 45.7771C13.4178 45.6468 13.606 45.5249 13.817 45.4142C14.026 45.3021 14.256 45.2027 14.5031 45.1158C14.7502 45.0276 15.0125 44.9547 15.2862 44.8945C15.5618 44.8342 15.8451 44.788 16.1378 44.7572C16.4286 44.7263 16.7232 44.7109 17.0216 44.7109C17.3181 44.7109 17.6128 44.7263 17.9055 44.7572C18.1963 44.788 18.4795 44.8342 18.7551 44.8945C19.0307 44.9547 19.2911 45.0276 19.5382 45.1158C19.7853 45.2027 20.0153 45.3021 20.2244 45.4142C20.4354 45.5249 20.6235 45.6468 20.7889 45.7771C20.9543 45.9088 21.093 46.046 21.2071 46.1917C21.3211 46.3374 21.4067 46.4873 21.4656 46.6414C21.5226 46.797 21.553 46.9525 21.553 47.1108Z",
    fill: "#101110"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1865 19.7188H34.001V34.2508H19.1865V19.7188Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11392_37575)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 19,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5957 19.7227C22.5034 19.7227 19.1885 22.9744 19.1885 26.9887C19.1885 31.0011 22.5034 34.2547 26.5957 34.2547C30.6861 34.2547 34.0029 31.0011 34.0029 26.9887C34.0029 22.9744 30.6861 19.7227 26.5957 19.7227Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11392_37575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1885 19.7227H34.0029V34.2547H19.1885V19.7227Z",
    fill: "#101110"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 22,
    width: 11,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9678 22.4434H31.2073V31.5068H21.9678V22.4434Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11392_37575)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11392_37575",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 22,
    width: 11,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5865 22.4434C24.0338 22.4434 21.9658 24.472 21.9658 26.976C21.9658 29.4782 24.0338 31.5068 26.5865 31.5068C29.1374 31.5068 31.2054 29.4782 31.2054 26.976C31.2054 24.472 29.1374 22.4434 26.5865 22.4434Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11392_37575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9658 22.4434H31.2054V31.5068H21.9658V22.4434Z",
    fill: "#101110"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.1157 28.1517C28.1157 27.0611 28.9445 26.275 30.0321 26.275C28.9951 26.275 28.1166 25.4375 28.1166 24.3973C28.1166 25.4276 27.2967 26.275 26.1992 26.275C27.2967 26.275 28.1157 27.1007 28.1157 28.1517Z",
    fill: "#101110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1157 24.3965L28.1166 24.3973M28.1166 24.3973C28.1166 25.4375 28.9951 26.275 30.0321 26.275C28.9445 26.275 28.1157 27.0611 28.1157 28.1517C28.1157 27.1007 27.2967 26.275 26.1992 26.275C27.2967 26.275 28.1166 25.4276 28.1166 24.3973Z",
    stroke: "#101110",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikkoBlocked);
export default __webpack_public_path__ + "static/media/pikkoBlocked.17a36a5679a4ebc139a7184919b86c50.svg";
export { ForwardRef as ReactComponent };